import cx from 'classnames'
import i18next from 'i18next'
import { PropsWithChildren, MouseEvent, ReactNode } from 'react'

import { useDisableScroll } from 'hooks'

import ConfirmBox from './ConfirmBox'
import Button, { ButtonProps } from './Button'

const ConfirmBoxBasic = ({
  isActive,
  onClose,
  onOk,
  className,
  zIndex,
  title,
  content,
  children,
  fluidButtons = false,
  loading,
  cancelContent,
  onCancel,
  cancelText,
  extraButtons = [],
  confirmButtonStyle,
  confirmButtonText,
  noOverlay,
  strictClose = false,
}: PropsWithChildren<{
  isActive: boolean
  onClose?: (e?: MouseEvent) => void
  onOk: (e?: MouseEvent) => void
  className?: string
  zIndex?: number
  title?: string
  content?: ReactNode
  fluidButtons?: boolean
  loading?: boolean
  cancelContent?: ReactNode
  onCancel?: (e?: MouseEvent) => void
  cancelText?: string
  extraButtons?: Array<{
    content: string
    onClick: Function
    style?: object
  }>
  confirmButtonStyle?: ButtonProps['buttonStyle']
  confirmButtonText?: string
  noOverlay?: boolean
  strictClose?: boolean
}>) => {
  useDisableScroll(isActive)

  return (
    <ConfirmBox isActive={isActive} className={className} zIndex={zIndex}>
      {!noOverlay && (
        <a
          className="ConfirmBox__overlay"
          onClick={strictClose ? undefined : onClose}
        />
      )}

      <div className="ConfirmBox__wrapper">
        <div className="ConfirmBox__body">
          {title && <h3 className="ConfirmBox__body__h3">{title}</h3>}
          {content && <p className="ConfirmBox__body__p">{content}</p>}
          {children}
        </div>

        <div
          className={cx('ConfirmBox__footer', {
            'ConfirmBox__footer--fluid': fluidButtons,
            'ConfirmBox__footer--x-disabled': loading,
          })}
        >
          {cancelContent
            ? cancelContent
            : onCancel &&
              !strictClose && (
                <Button buttonStyle="white" onClick={onCancel}>
                  {cancelText || i18next.t('common.cancel')}
                </Button>
              )}

          {onClose &&
            extraButtons.map(({ content, onClick, ...otherProps }) => (
              <Button
                key={content}
                onClick={() => {
                  onClick()
                  onClose()
                }}
                loading={loading}
                {...otherProps}
              >
                {content}
              </Button>
            ))}

          <Button
            onClick={onOk}
            buttonStyle={confirmButtonStyle}
            loading={loading}
          >
            {confirmButtonText || i18next.t('common.yes')}
          </Button>
        </div>
      </div>
    </ConfirmBox>
  )
}

export default ConfirmBoxBasic
